import React, { ButtonHTMLAttributes } from "react";
import classes from "./index.module.css";
import { Button as MantineButton, UnstyledButton as MantineUnstyledButton } from "@mantine/core";
import { ButtonProps as MantineButtonProps } from "@mantine/core";
import { pushCtaClick, extractText, buildCtaDestination, type CtaPosition } from "@/utils/dataLayer";
import { useCtaPosition } from "@/contexts/CtaPositionContext";

export type ButtonProps = MantineButtonProps &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    ctaPosition?: CtaPosition;
    ctaDestination?: string;
  };

const Button = ({ ctaPosition, ctaDestination, onClick, children, unstyled, ...props }: ButtonProps) => {
  const contextPosition = useCtaPosition();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    pushCtaClick(
      ctaPosition ?? contextPosition,
      ctaDestination ?? buildCtaDestination(window.location.pathname),
      extractText(children)
    );
    onClick?.(e as React.MouseEvent<HTMLButtonElement> & React.MouseEvent<HTMLElement>);
  };

  if (unstyled) {
    return (
      <MantineUnstyledButton onClick={handleClick} {...(props as React.ComponentProps<typeof MantineUnstyledButton>)}>
        {children}
      </MantineUnstyledButton>
    );
  }

  return (
    <MantineButton classNames={classes} onClick={handleClick} {...props}>
      {children}
    </MantineButton>
  );
};

export default Button;
